module.exports = __webpack_public_path__ + "4da2b97fc6fc6ca3d630d51bf42fda47.svg";